import { z } from "@/zod";
import { ulid } from "./commonFields/ulid";

const disabilityCertificate = z.object({
  id: ulid,
  code: z.string().min(1),
  description: z.string().min(1),
});

export const readDisabilityCertificate = disabilityCertificate.readonly();
export const writeDisabilityCertificate = disabilityCertificate.omit({
  id: true,
});
